module.exports = __webpack_public_path__ + "img/instagram-logo.58826486.svg";